module.exports = __webpack_public_path__ + "static/icon-723aedd1bdbf1950b3ee05dc62c9908f.png";